webpackJsonp([150237720280904],{

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(33);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _productcard = __webpack_require__(86);
	
	var _productcard2 = _interopRequireDefault(_productcard);
	
	var _reactHelmet = __webpack_require__(41);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _productfilters = __webpack_require__(106);
	
	var _productfilters2 = _interopRequireDefault(_productfilters);
	
	var _semanticUiReact = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IntegrationPage = function (_Component) {
	  _inherits(IntegrationPage, _Component);
	
	  function IntegrationPage() {
	    _classCallCheck(this, IntegrationPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  IntegrationPage.prototype.render = function render() {
	    var _props$data$contentfu = this.props.data.contentfulIntegration,
	        name = _props$data$contentfu.name,
	        product = _props$data$contentfu.product,
	        id = _props$data$contentfu.id,
	        website = _props$data$contentfu.website;
	
	    return _react2.default.createElement(
	      'div',
	      { style: { maxWidth: 1260, margin: '0 auto' } },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'See the software that integrates with ',
	          name,
	          ' | Find Growth Tools'
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: 'The best SaaS tools that integrate with ' + name + ' in 2019, with features, pricing, customers and more.' })
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Segment,
	        { basic: true },
	        _react2.default.createElement(
	          _semanticUiReact.Breadcrumb,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Breadcrumb.Section,
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/integrations', style: { color: '#dcddde' } },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'angle left' }),
	              'All Integrations'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'h1',
	        {
	          style: {
	            fontSize: '1.5rem',
	            color: '#fff'
	          }
	        },
	        'Integrates with',
	        _react2.default.createElement(
	          'span',
	          { style: { fontSize: '3.25rem' } },
	          ' ',
	          name
	        )
	      ),
	      website ? _react2.default.createElement(
	        _semanticUiReact.Segment,
	        { compact: true, basic: true, inverted: true, style: { background: '#0d161e' } },
	        _react2.default.createElement(
	          _semanticUiReact.List,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.List.Item,
	            null,
	            _react2.default.createElement(_semanticUiReact.List.Icon, { name: 'linkify' }),
	            _react2.default.createElement(
	              _semanticUiReact.List.Content,
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: website, target: '_blank' },
	                website
	              )
	            )
	          )
	        )
	      ) : _react2.default.createElement('span', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { style: { maxWidth: 760, margin: '0 auto' } },
	        _react2.default.createElement(
	          _semanticUiReact.Segment,
	          { basic: true },
	          _react2.default.createElement(
	            'p',
	            {
	              style: { fontSize: '1.25em', color: '#fff', textAlign: 'center' }
	            },
	            'Connect ',
	            name,
	            ' with the tools below to create a powerful growth marketing tech stack.'
	          )
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          { textAlign: 'center' },
	          product ? product.map(function (product) {
	            return _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_productcard2.default, { node: product }),
	              _react2.default.createElement('br', null)
	            );
	          }) : _react2.default.createElement(
	            'span',
	            null,
	            'Nothing yet! Check back soon :)'
	          )
	        )
	      )
	    );
	  };
	
	  return IntegrationPage;
	}(_react.Component);
	
	IntegrationPage.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = IntegrationPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-integration-page-js-2ab0f7a24e1ebb15f915.js